import type { CategoryContent } from '../row.js';

export const PORTUGUESE_HISTORY: CategoryContent = {
  bscba: [
    [
      'Wanneer werd het Koninkrijk Portugal als onafhankelijke christelijke staat gesticht?',
      ['1143', '1139', '1297', '1385'],
      0,
      'Portugal werd in 1143 onafhankelijk onder Afonso Henriques. Het Verdrag van Zamora (1297) formaliseerde later de erkenning door Castilië.',
    ],
    [
      'Wie was de eerste Koning van onafhankelijk Portugal?',
      ['Afonso I Henriques', 'Ferdinand I van Castilië', 'Diniz I', 'Johan I van Avis'],
      0,
      'Afonso I Henriques (r. 1143–1185) stichtte de Portugese monarchie. Johan I kwam later in 1385 en stichtte het Huis Avis.',
    ],
    [
      'Wat was de Reconquista?',
      ['Herovering van moslim-Iberia', 'Een islamitische invasie uit Noord-Afrika', 'Een zeeoorlog tegen het Ottomaanse Rijk', 'Een populaire opstand tegen de Inquisitie'],
      0,
      'De Reconquista (8e–15e eeuw) was de geleidelijke herovering van het Iberisch Schiereiland door christelijke koninkrijken. Het eindigde met de val van Granada in 1492.',
    ],
    [
      'Welke eeuw leidden Portugese ontdekkingsreizigers het Tijdperk der Ontdekkingen?',
      ['15e eeuw', '13e eeuw', '14e eeuw', '16e eeuw'],
      0,
      'Het Tijdperk der Ontdekkingen begon in de 15e eeuw, voortgestuwd door mecenassen als Hendrik de Zeevaarder. Portugese verkenners brachten kusten van Afrika tot Azië in kaart.',
    ],
    [
      'Wat was het belang van Vasco da Gama\'s tocht van 1498?',
      ['Een directe zeeweg naar Azië', 'Hij veroverde Indië voor Portugal', 'Hij ontdekte Amerika', 'Hij bewees dat de aarde rond was'],
      0,
      'Da Gama\'s reis creëerde de Kaapse Route, wat directe maritieme handel tussen Europa en Azië mogelijk maakte. Dit omzeilde de door Ottomanen gecontroleerde landroutes.',
    ],
    [
      'Tijdens de Iberische Unie (1580–1640), wat was de relatie tussen Portugal en Spanje?',
      ['Dezelfde vorst, aparte koninkrijken', 'Portugal werd een Spaanse provincie', 'Ze fuseerden tot één natie', 'Spanje trok zich uit Portugees grondgebied terug'],
      0,
      'De Iberische Unie betekende dat Portugal en Spanje dezelfde vorsten hadden, maar Portugal behield zijn afzonderlijke rechtsstelsels, adel en institutionele structuren.',
    ],
    [
      'Hoe lang duurde de Iberische Unie?',
      ['60 jaar', '40 jaar', '80 jaar', '100 jaar'],
      0,
      'De Iberische Unie duurde 60 jaar (1580–1640). Het eindigde toen Johan IV de Portugese onafhankelijkheid afkondigde en het Huis Braganza stichtte.',
    ],
    [
      'Wie leidde Portugals herstel van onafhankelijkheid in 1640?',
      ['Johan IV', 'Afonso III', 'Manuël I', 'Hendrik de Zeevaarder'],
      0,
      'Johan IV van Braganza leidde de Portugese Restauratie (Restauração) in 1640, waarbij Spaanse heerschappij werd omvergeworpen en een dynastie werd gesticht die tot 1910 regeerde.',
    ],
    [
      'Welk Portugees grondgebied riep onafhankelijkheid uit in 1822?',
      ['Brazilië', 'Goa', 'Macau', 'Oost-Timor'],
      0,
      'Brazilië verklaarde in 1822 onafhankelijkheid als het Keizerrijk Brazilië. Het was Portugals grootste en meest winstgevende kolonie.',
    ],
    [
      'Wanneer werd Portugals Eerste Republiek gesteld?',
      ['1910', '1865', '1895', '1920'],
      0,
      'De Eerste Republiek begon in 1910 na een revolutie die Koning Manuël II afzette, de laatst constitutionele vorst van het Huis Braganza.',
    ],
    [
      'Wat was de Estado Novo?',
      ['Een dictatuur vanaf 1926', 'Een democratische hervormingsbeweging', 'Een economische unie met Spanje', 'Een koloniaal onafhankelijkheidscampagne'],
      0,
      'De Estado Novo ("Nieuwe Staat") was een autoritair regime dat Portugal van 1926 tot 1974 regeerde, voortkomend uit een militaire coup.',
    ],
    [
      'Wie was de primaire dictator van Portugals Estado Novo?',
      ['Salazar', 'Getúlio Vargas', 'Miguel Primo de Rivera', 'Francisco Franco'],
      0,
      'António de Oliveira Salazar regeerde Portugal van 1932 tot 1968. Zijn Estado Novo was een van Europa\'s langstdurende dictaturen.',
    ],
    [
      'In welk jaar vond de Anjerrevolutie plaats?',
      ['1974', '1964', '1984', '1952'],
      0,
      'De Anjerrevolutie vond plaats op 25 april 1974, wat 48 jaar dictatuur beëindigde en democratie vestigde.',
    ],
    [
      'Waarom wordt de revolutie van 1974 de "Anjerrevolutie" genoemd?',
      ['Anjers werden in geweren geplaatst', 'Anjers waren de officiële nationale bloem', 'Het gebeurde tijdens de lente', 'Een revolutionaire leider heette Anjer'],
      0,
      'Burgers van Lissabon plaatsten spontaan rode anjers in de geweren van soldaten en droegen de bloemen ook zelf. De anjer werd een iconisch symbool van de vreedzame revolutie.',
    ],
    [
      'Wat voor regering nam Portugal aan na de Anjerrevolutie?',
      ['Een parlementaire republiek', 'Een constitutionele monarchie', 'Een socialistische staat', 'Een militaire junta'],
      0,
      'Portugal werd een democratische republiek met scheiding der machten, een parlementair stelsel, en trad later in 1986 toe tot de Europese Unie.',
    ],
  ],
  msc: [
    [
      'Het historiografische debat over de stichting van Portugal concentreert zich op of de Slag van Ourique (1139) was:',
      ['Waarschijnlijk een legendarische uitvinding', 'De enige significante militaire gebeurtenis in Portugese geschiedenis', 'Bewezen door gelijktijdige islamitische bronnen', 'Irrelevant voor Portugese onafhankelijkheid'],
      0,
      'Moderne geleerden debatteren over Ourique\'s historiciteit; sommigen stellen dat het een literaire uitvinding was. Het Verdrag van Zamora (1297) biedt sterker bewijs van formele erkenning.',
    ],
    [
      'Welke economische factor stelde Portugese ontdekkingstochten het meest mogelijk?',
      ['Suiker uit Madeira en de Azoren', 'Goud alleen uit West-Afrikaanse handel', 'Specerij-monopolies uit Zuidoost-Azië', 'Woltextiel-export naar Vlaanderen'],
      0,
      'Suikerplantages op Atlantische eilanden genereerden kapitaal voor exploratie. Deze eilanden werden later modellen voor Caribische slavenplantages.',
    ],
    [
      'Waar verwees "Estado da Índia" (Staat van Indië) naar?',
      ['Een netwerk van forten en handelsposten', 'Een voorgestelde federatie van Aziatische koninkrijken', 'Het grondgebied rond Goa alleen', 'De eerste Europese handelspost in Indië'],
      0,
      'De "Staat van Indië" was een gedecentraliseerd netwerk van forten (Goa, Cochin, Diu) en handelsposten. Het controleren van zeestraten was belangrijker dan territoriaal beheer.',
    ],
    [
      'De vordering van Filips II van Spanje op de Portugese troon in 1580 was gebaseerd op de dood van welke erfgenaam?',
      ['Kardinaal Hendrik, laatste Avis', 'Johan III zonder legitieme opvolger', 'Koning Sebastiaans oom', 'Erfgenaam van Manuël I'],
      0,
      'Kardinaal Hendrik (1578–1580) was de laatste Avis-koning met rechtstreekse mannelijke erfgenamen. Filips II eiste via zijn moeder de troon op, wat tot de Iberische Unie leidde.',
    ],
    [
      'Waarom steunde de Portugese adel de Restauratie van 1640 ondanks het Spaanse militaire risico?',
      ['Stijgende belastingen en uitsluiting van ambten', 'Portugal ontdekte plotseling rijkdom in Brazilië', 'Een populaire opstand dwong de adel', 'Frankrijk garandeerde militaire steun'],
      0,
      'Castiliaanse belastingverhogingen (vooral de tinta-omzetbelasting) en uitsluiting van Spaanse ambten voedden wrok. Spanje\'s betrokkenheid bij de Dertigjarige Oorlog beperkte het reactievermogen.',
    ],
    [
      'Wat bereikte het Verdrag van Lissabon (1668)?',
      ['Spanje erkende Portugese soevereiniteit', 'Portugal verwierf controle over Spaanse koloniën', 'Het creëerde een defensief verbond tegen Frankrijk', 'Het herstelde Portugese controle over Indië'],
      0,
      'Spanje erkende Portugese onafhankelijkheid formeel in 1668, waarmee decennia van militair conflict en internationale onzekerheid over Braganza-legitimiteit eindigden.',
    ],
    [
      'Het burgerconflict in Portugal van 1826–1834 stelde welke twee facties tegen elkaar?',
      ['Liberalen tegen absolutisten', 'Republikeinen tegen monarchisten', 'Rijke kooplieden tegen arme boeren', 'Portugal tegen Spanje'],
      0,
      'Liberale constitutionalisten vochten tegen absolutisten over bestuur en kerkelijk bezit. Britse interventie steunde de constitutionele zijde en vormde de moderne Portugese politiek.',
    ],
    [
      'Wat precipiteerde de republikeinse revolutie van 1910 die de monarchie omwierp?',
      ['De moord op Koning Carlos I en zijn erfgenaam', 'Economische ineenstorting door koloniale verliezen', 'Militaire muiterij over lonen', 'Druk van de nieuw uitgeroepen Spaanse Republiek'],
      0,
      'Koning Carlos en zijn oudste zoon werden op 1 februari 1910 vermoord. De opvolgende koning regeerde slechts twee jaar voordat de Republiek werd afgekondigd.',
    ],
    [
      'Wat structureel probleem maakte de Eerste Republiek (1910–1926) politiek instabiel?',
      ['Kiesregels fragmenteerden het parlement', 'Het was te democratisch', 'De Senaat had te veel macht', 'Economische welvaart veroorzaakte zelfvoldaanheid'],
      0,
      'Proportionele vertegenwoordiging creëerde 16 regeringen in 16 jaar. Een zwak presidentschap en onopgeloste sociale verdelingen maakten de republiek kwetsbaar voor militaire inmenging.',
    ],
    [
      'Welke ideologische traditie beïnvloedde Salazars corporatistische Estado Novo het meest?',
      ['Portugees integralisme', 'Zuiver marxisme', 'Liberale democratie', 'Islamitische politieke theorie'],
      0,
      'Salazar, een katholieke integralista, baseerde de Estado Novo op kerkelijke leerstellingen over sociale hiërarchie. In tegenstelling tot fascisme miste het Portugese corporatisme raciale biologisme.',
    ],
    [
      'Tijdens de Tweede Wereldoorlog, welk strategisch doel diende Portugals wolfram-levering aan Duitsland?',
      ['Hefboomkracht tegen As en Geallieerden', 'Het was slechts een commerciële transactie', 'Het signaleerde fascistische verbintenis', 'Portugal had geen keuze'],
      0,
      'Wolfram was essentieel voor tankpantser. Portugals levering stelde Salazar in staat om beide zijden tegen elkaar uit te spelen. Dit financierde de Estado Novo, terwijl het land officieel neutraliteit voorwendde.',
    ],
    [
      'De geheime politie onder Salazar, de PIDE-DGS, opereerde voornamelijk via:',
      ['Betaalde middenklasse-informanten', 'Massale aanhoudingen en terreur', 'Geavanceerde bewakingstechnologie', 'Militaire patrouilles en controleposten'],
      0,
      'PIDE vertrouwde op aangiftenetwerken in plaats van gecentraliseerde bewaking. Dit maakte het episodisch wreed maar organisatorisch minder efficiënt dan de Sovjet- of nazi-geheime politie.',
    ],
    [
      'Hoe destabiliseerden de Koloniale Oorlogen (1961–1974) de Estado Novo?',
      ['Kostbare oorlogen voedden officeronvrede', 'De oorlogen werden beslissend gewonnen', 'Koloniale troepen gingen onmiddellijk over', 'De VN greep militair in'],
      0,
      'Oorlogen in Angola, Guinee-Bissau en Mozambique putten het budget uit en wierven jongere officieren in die de levensvatbaarheid van het regime betwijfelden. Militaire nederlaag voedde de coup van 1974.',
    ],
    [
      'Waarom slaagde de coup van de Beweging van de Gewapende Strijdkrachten (MFA) in 1974 met minimaal bloedvergieten?',
      ['Weigering om te schieten', 'Het hele leger muitte', 'De regering kapituleerde vrijwillig', 'Internationale druk dwong naleving'],
      0,
      'Het regime verloor dwangmacht toen dienstplichtigen fraterniseerden met burgers in plaats van te schieten. Verdeeldheid onder de officieren voorkwam dat het regime geweld kon gebruiken tegen de coup.',
    ],
    [
      'De Portugese Grondwet van 1976 vestigde wat voor vorm van regering?',
      ['Een semi-presidentieel stelsel', 'Zuivere parlementaire democratie', 'Een federalistische structuur met autonome regio\'s', 'Militaire controle via institutionele raad'],
      0,
      'De Grondwet van 1976 creëerde een hybride systeem met een sterke rechtstreeks gekozen president met parlementair toezicht. Dit weerspiegelde het compromis na 1974.',
    ],
  ],
  phd: [
    [
      'Fernanda Fonseca en andere revisionistische geleerden stellen dat Portugese nationale bewustzijn voortkwam van:',
      ['Geleidelijke divergentie', 'Alleen de Slag van Ourique', 'Volledige scheiding van Leonese recht', 'Koninklijke huwelijksallianties'],
      0,
      'Moderne historiografie benadrukt institutionele geleidelijkheid: kerkbelastingvrijstellingen, juridische autonomie en administratieve scheiding gingen aan militaire onafhankelijkheidsclaims vooraf.',
    ],
    [
      'Het historiografische debat tussen "commercieel netwerk" en "imperiale extractieve" raamwerk van de Estado da Índia concentreert zich op:',
      ['Of handelsnetwerken kolonialisme waren', 'Winstgevendheid van afzonderlijke forten', 'Of Portugal schriftelijk koloniaal beleid had', 'Aantal Portugese kolonisten'],
      0,
      'Thomaz\' handelsnetwerkmodel bagatelliseert systematische dwang; postkoloniale geleerden stellen dat het cartaz-systeem, slavernij en dwangarbeid kolonialisme vormen.',
    ],
    [
      'De structurele wortels van de Restauratie van 1640 lagen in:',
      ['Castiliaanse fiscale integratie', 'Zuivere haat van Spaanse heerschappij', 'Een uniforme populaire opstand', 'Persoonlijke tirannie van de Spaanse koning'],
      0,
      'Spaanse fiscale centralisatie onder Olivares verhoogde directe heffingen. De tinta-belasting op voedingsmiddelen bedreigde handelswinsten, waardoor fiscale autonomie de materiële basis voor opstand werd.',
    ],
    [
      'Met betrekking tot de Miguelische Oorlogen benadrukt moderne wetenschap dat de liberale overwinning was:',
      ['Afhankelijk van Britse interventie', 'Onvermijdelijk door liberalisme\'s superioriteit', 'Irrelevant voor Portugese geschiedenis', 'Volledig beslist door boerenactie'],
      0,
      'De absolutistische factie behield regionale sterkte; liberale triomf hing af van Britse interventie (1831–1834) en het onvermogen om een eensgezinde absolutistische coalitie te herbouwen.',
    ],
    [
      'De fiscale crisis van de Eerste Republiek (tekorten tegen 1912) voortkwam uit:',
      ['Verlies van inkomsten, vervreemding van rurale elites', 'Uitsluitend mismanagement', 'Externe monarchistische sabotage', 'Buitensporige militaire uitgaven voor koloniale oorlogen'],
      0,
      'Liberale hervormingen vervreemdden agraire landeigenaren; tariefsverlagingen deden de inkomsten dalen. De staat kon niet tegelijkertijd uitgeven, instituties hervormen en belastingen innen.',
    ],
    [
      'Salazars filosofische schuld aan integralistische theoreticus Mário de Sacadura Cabral manifesteerde in:',
      ['Corporatisme naar gildenmodel', 'Aannemen van nazi-rassentheorie', 'Verbintenis met democratie', 'Geen systematische filosofie'],
      0,
      'Salazar baseerde corporatisme op scholastisch natuurrecht en middeleeuwse gildenovellen. In tegenstelling tot fascisme ontbeerde het revolutionaire dynamiek en raciale biologisme.',
    ],
    [
      'Portugals WWII "niet-strijdendheid" verborg:',
      ['Omgang met beide kanten', 'Volledige neutraliteit', 'Verbintenis met de Geallieerden', 'Onwetendheid van nazi-activiteiten'],
      0,
      'Gestapo-agenten opereerden ongehinderd in Lissabon; de regering tolereerde Britse inlichtingen terwijl wolfram aan Duitsland werd verkocht. "Neutraliteit" was performatieve afdekking.',
    ],
    [
      'De structurele effectiviteit van de PIDE-DGS geheime politie voortkwam uit:',
      ['Middenklasse-informantennetwerken', 'Superieure bewakingstechnologie', 'Massale gevangenisprogramma\'s', 'Militaire dominantie en patrouilles'],
      0,
      'PIDE ontbeerde gecentraliseerde archieven of technische geavanceerdheid; het vertrouwde op informantennetwerken. Dit creëerde wantrouwen maar maakte het kwetsbaar toen militaire steun wegviel.',
    ],
    [
      'Na 1964 escaleerden de Koloniale Oorlogen in militaire betekenis omdat:',
      ['Naar conventionele oorlog', 'Portugal won beslissend', 'Geallieerde interventie slaagde', 'Een vredesakkoord werd onderhandeld'],
      0,
      'Van 1970–1974 gebruikten opstandelingen conventionele tactieken; Portugese verliezen piekten. Deze militaire patstelling overtuigde de officieren dat het regime bankroet was.',
    ],
    [
      'De interne ideologische heterogeniteit van de MFA (communisten, socialisten, liberalen) werd naar democratie gestabiliseerd via:',
      ['De socialistische overwinning van 1976', 'Een overname door de Communistische Partij', 'Franse militaire interventie', 'Ideologische consensus links'],
      0,
      'De Socialistische Partij won de verkiezingen van 1976; de CP ontbeerde eensgezind leiderschap in de MFA. Westerse druk (EU-toetreding) duwde het leger richting grondwettelijke democratie.',
    ],
    [
      'Lusotropicalisme—Salazars ideologische rechtvaardiging van Portugese kolonialisme via Freyre\'s werk—stelde:',
      ['Welwillende rassenvermenging door temperament', 'Koloniën ontvingen gelijke behandeling', 'Ras speelde geen rol in Portugese kolonialisme', 'De theorie was wetenschappelijk bewezen'],
      0,
      'Freyre stelde dat Portugese kolonisators rassenflexibiliteit vertoonden, wat harmonieuze vermenging produceerde. Postkoloniale wetenschap toont dit maskerend van brutale rassenafscheiding.',
    ],
    [
      'Waarom dekoloniseerde Portugal onmiddellijk (binnen weken) na de Anjerrevolutie?',
      ['Een radicale factie versnelde de dekolonisatie', 'De koloniën eisten eendrachtig onafhankelijkheid', 'Koloniale oorlogen waren geëindigd', 'Internationaal recht vereiste het'],
      0,
      'Radicale MFA-president Gonçalves handelde snel inzake dekolonisatie om conservatieve officieren te beletten controle te herwinnen. Dit liet machtsvacua achter die werden gevuld door Koude Oorlog-facties.',
    ],
    [
      'Het semi-presidentiële stelsel van de Grondwet van 1976 weerspiegelde:',
      ['Een MFA-parlementair compromis', 'Zuivere parlementaire suprematie', 'Formeel militaire dictatuur', 'Presidentalisme zonder controles'],
      0,
      'De Raad van de Revolutie verleende officieren institutioneel vetorecht. Grondwetswijzigingen (1982, 1989) verschoven geleidelijk naar zuiver parlementarisme.',
    ],
    [
      'Portugese EU-toetredingsonderhandelingen (1977–1985) stonden voor obstakels van:',
      ['Zware EU-alignmentseisen', 'EU-afwijzing', 'Portugese weigering', 'Snelle, onbetwiste integratie'],
      0,
      'Portugese wetgeving aanpassen aan EU-normen bleek administratief zwaar terwijl dekolonisatie statelijke capaciteit uitputte. Agraire belangen weerstonden tariefliberalisatie.',
    ],
    [
      'Recente wetenschap (Pina Cabral, Vilar) over Portugese regionale identiteit betoogt dat natievorming systematiseerde:',
      ['Uitwissing van eigenheid', 'Respect voor regionale autonomie', 'Federale politieke structuren', 'Geen natievorming vond plaats'],
      0,
      'Cabral en anderen tonen aan hoe Estado Novo-centralisatie en katholiek nationalisme Moorse, Sefardische en regionale cultuurerfenissen uitwisten die ten grondslag lagen aan Portugese heterogeniteit.',
    ],
  ],
  professor: [
    [
      'Revisionistische historiografie over het Verdrag van Zamora (1297) benadrukt dat het formaliseerde in plaats van onafhankelijkheid creëerde, wat het methodische probleem opwekt van:',
      ['Het dateren van statievorming', 'Of Zamora een werkelijk verdrag was', 'Betrouwbaarheid van middeleeuwse kronieken', 'Rol van militaire verovering'],
      0,
      'Moderne geleerden debatteren of onafhankelijkheid voortkomt uit dynastieke verklaring, institutionele rijping of verdragserkenning. Zamora\'s betekenis ligt in het formaliseren van voorafgaande institutionele divergentie.',
    ],
    [
      'De historiografische revisie van Portugese Atlantische expansie van "handelsnetwerk" naar "koloniaal" raamwerk berust op archiefbewijzen van:',
      ['Dwangarbeid en zeegeweld', 'Aantal gebouwde forten', 'Schriftelijke koloniale chartes', 'Kolonistenstatistieken'],
      0,
      'Archiefbewijzen van slavernij in Madeira, cartaz-handhaving en inheems bevolkingsverlies tegenspreken het handelsnetwerknarratief. Portugese expansie betrok extractieve, gekleurde arbeidsregimes in.',
    ],
    [
      'De fiscale trigger van de Restauratie van 1640 (Olivares\' tinta-belastingverhoging) toont dat Portugese eliteopstand was:',
      ['Bedreigde handelswinsten', 'Zuiver nationaal trots', 'Gebaseerd op populaire vraag', 'Een intellectuele beweging'],
      0,
      'De tinta-belasting bedreigde handelswinsten rechtstreeks. Portugese historiografie romantiseert de Restauratie als patriottisch; ze was fundamenteel een elitaire reactie op fiscale integratie.',
    ],
    [
      'Met betrekking tot de Miguelische Oorlogen toont archivaal onderzoek door Carvalho Monteiro aan dat het absolute militaire vermogen ondermijnd werd door:',
      ['Splijting om eigendom', 'Uitsluitend Britse interventie', 'Populaire liberale vraag', 'Gebrek aan financiële middelen'],
      0,
      'Beslaglegging op kerkelijk eigendom vervreemdde gekleurde absolutisten; plattelandsabsolutisten en stedelijke facties raakten verdeeld. Deze interne verdeeldheid, uitgebuit door liberalen, bleek doorslaggevend.',
    ],
    [
      'De fiscale ineenstorting van de Eerste Republiek vanaf 1912 was gegrond in de institutionele onmogelijkheid van:',
      ['Bureaucratie en belastingen', 'Behoud monarchie', 'Koloniale territoria controleren', 'Militaire interventie voorkomen'],
      0,
      'Liberale hervormingsretoriek vervreemdde landeigenaren die belastinginning controleerden. De staat kon het zich niet veroorloven inkomstenbronnen te verliezen terwijl de uitgaven voor bureaucratische modernisering toenamen.',
    ],
    [
      'Salazars corporatistische ideologie divergeerde van fascisme door legitimiteit in te voelen:',
      ['Katholiek natuurrecht', 'Rassensuperieurheid', 'Democratische instemming', 'Marxistische dialectiek'],
      0,
      'Salazar riep scholasticisme en middeleeuwse gildeorganisatie aan. In tegenstelling tot het vitalisme en het raciale biologisme van het fascisme benadrukte het Portugese corporatisme een traditionele katholieke maatschappelijke orde.',
    ],
    [
      'Portugals WWII wolfram-export naar Duitsland opereerde binnen een geopolitieke logica van:',
      ['Afdekking tussen beide kanten', 'Steun voor nazi-ideologie', 'Neutraliteit gebaseerd op afstand', 'Alleen economische noodzaak'],
      0,
      'Salazar profiteerde van beide zijden door wolfram aan Duitsland te verkopen terwijl Britse operaties in Lissabon werden getolereerd. Formele neutraliteit maskeerde berekend opportunisme.',
    ],
    [
      'De kwetsbaarheid van de PIDE-DGS geheime politie in 1974 voortkwam uit:',
      ['Steun op informanten', 'Moderniseringsfouten', 'Gebrek aan training', 'Buitensporige centralisatie'],
      0,
      'PIDE ontbeerde een onafhankelijk handhavingsapparaat; het vertrouwde op informantennetwerken. Militaire terugtrekking ondermijnde het vermogen om het aangifteregime in stand te houden.',
    ],
    [
      'De transitie van de Koloniale Oorlogen van counterinsurgency naar conventionele oorlogvoering (FRELIMO\'s offensief van 1970–74) signaleerde aan officieren dat:',
      ['Middelen uitgeput zonder overwinning', 'Portugal wint', 'Internationale bemiddeling zou slagen', 'De oorlogen zouden onmiddellijk eindigen'],
      0,
      'Stijgende verliezen, territoriële toegevingen en FRELIMO\'s conventionele capaciteiten toonden aan dat het regime niet kon winnen. Officieren concludeerden dat de voortdurende oorlog de institutionele stabiliteit bedreigde.',
    ],
    [
      'De linksverschuiving van de MFA (1974–76) volgde een patroon van revolutionaire militaire radicalisering, maar de verschuiving naar democratie werd geconsolideerd door:',
      ['De socialistische triomf van 1976', 'Communistische electorale overwinning', 'Sovjet-druk', 'Socialistische ideologie'],
      0,
      'De overwinning van de Socialistische Partij in 1976 ondergroef communistische en radicale vorderingen. Westerse stimuleringsstructuren (NAVO, EU-toetreding) maakten liberale democratie aantrekkelijker dan alternatief autoritarisme.',
    ],
    [
      'Lusotropicalisme zoals ingezet door Salazars regime functioneerde als:',
      ['Dwang als vermenging', 'Wetenschappelijke waarheid', 'Een kritiek op racisme', 'Een economische theorie'],
      0,
      'Freyre\'s lusotropicalisme legitimeerde geforceerde assimilatie en rassenwerken door vermenging te romantiseren. Salazar bewapende het om extractief kolonialisme als cultureel welwillend te verdedigen.',
    ],
    [
      'De onmiddellijke dekolonisatie (decreet binnen weken) onder radicale MFA-president Gonçalves vond plaats omdat:',
      ['Snelheid als tactiek', 'Vreedzame onderhandeling', 'Internationale vraag', 'Koloniale akkoord'],
      0,
      'Gonçalves en radicale bondgenoten ontwierpen snelle dekolonisatie om conservatieve officieren te beletten met koloniale elites te onderhandelen. Snelheid was revolutionaire tactiek, geen consensus.',
    ],
    [
      'De Raad van de Revolutie van de Grondwet van 1976 (militair veto over executive) vertegenwoordigde:',
      ['Vastgelopen MFA-rifts', 'Permanente militaire regel', 'Zuivere burgersuprematisme', 'Geen militaire invloed'],
      0,
      'De Raad institutionaliseerde militaire institutionele belangen zonder dictatuur te creëren. Opeenvolgende grondwetsherzieningen verminderden geleidelijk haar bevoegdheden naarmate democratie consolideerde.',
    ],
    [
      'Portugese EU-toetreding vereiste administratieve harmonisatie vooral in:',
      ['Arbeidsregels', 'Grenscontrole', 'Militaire aankoop', 'Nationaal taalbeleid'],
      0,
      'EU acquis communautaire (vooral arbeids- en milieustandaarden) conflicteerde met Portugese industriële en agraire belangen. Dekolonisatie beperkte statelijke harmonisatiecapaciteit.',
    ],
    [
      'Het historiografische debat over "Portugese identiteit" (Pina Cabral, Lopes da Silva) benadrukt dat nationale consolidatie betrokken was:',
      ['Uitgewiste minderheidserfenissen', 'Natuurlijke culturele eenheid', 'Afwezigheid van regionale diversiteit', 'Federalistische accommodatie'],
      0,
      'Wetenschap toont aan hoe natievorming in de 19e–20e eeuw Moorse architectuurerfenissen uitwiste, Sefardische gemeenschappen uitdreef en regionale identiteiten ondergeschikt maakte aan het nationalistische narratief.',
    ],
  ],
};
